import React, { useState, useEffect } from "react";
import { Box, Typography } from '@mui/material'

export const GalleryFormSectionHeading = ({ heading, subHeading }) => {
  const headingStyling = {
    color: '#000',
    fontSize: 12,
    width: '100%',
    fontWeight: 600,
    margin: '20px auto 10px',
    textDecoration: 'underline'
  }
  const subHeadingStyling = {
    fontSize: 12,
    fontWeight: 600,
    color: '#606060',
    margin: '0px auto 10px',
  }
  return (    
    <Box>
      <Typography sx={headingStyling}>
        { heading }
      </Typography>
      {subHeading &&
       <Typography sx={subHeadingStyling}>
         {subHeading} 
       </Typography>
      }
    </Box>
    
  )
}
